const data = [
  { day: 'Monday', 'Number of posts': 13855 },
  { day: 'Tuesday', 'Number of posts': 14519 },
  { day: 'Wednesday', 'Number of posts': 14266 },
  { day: 'Thursday', 'Number of posts': 13848 },
  { day: 'Friday', 'Number of posts': 13145 },
  { day: 'Saturday', 'Number of posts': 10807 },
  { day: 'Sunday', 'Number of posts': 11402 },
];

export default data;
